module.exports = __webpack_public_path__ + "img/partly_cloudy.57264e12.svg";